export abstract class AbandonedCardRules {
  abstract abandonedIcon: string;
}
